import { render } from "solid-js/web";
import { App } from "./App.tsx";
import { initI18n } from "./i18n.ts";
import { loadSession, session, startLive } from "./services.ts";
import { loadPreferences } from "./preferences.ts";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "./theme.css";
import "./app.css";

await Promise.all([initI18n(), loadSession()]);
await loadPreferences();
// The live hub requires a session; signing in reloads the page, so this is the only place to start it.
if (session().status === "signedIn") {
  startLive();
}
render(() => <App />, document.getElementById("root")!);
